import React, { Fragment } from 'react';
import { Input, ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import FormErrors from 'components/formErrors/FormErrors';

export const inputFields = (data, handleUserInput) => {
    return (
        <Fragment>
            <div className="col-lg-9 d-flex flex-column order-lg-1">
                <h3 className="card-heading">{<IntlMessages id="label.name" />}</h3>
                <Input id="name" type="text" className={`form-control mb-2 ${data?.name ? 'is-valid' : 'is-invalid'}`}
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.name} name="name"
                />
                <h3 className="card-heading">{<IntlMessages id="label.description" />}</h3>
                <Input id="description" type="text" className="form-control mb-2"
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.description} name="description"
                />
            </div>
        </Fragment>
    );
};

export const displayedImage = (selectedPortfolio) => {
    return (
        <div className="col-lg-3 text-center text-lg-right order-lg-2">
            <img id="thumb" className="ml-lg-3 mb-4 mb-lg-0 avatar size-120" src={selectedPortfolio?.thumb || 'assets/images/portfolios-1_225_225.jpg'} />
        </div>
    );
};

export const showErrors = (formErrors) => {
    if (formErrors) {
        return (
            <div className="panel panel-default">
                <FormErrors formErrors={formErrors} />
            </div>
        );
    }
    return null;
};

export const modalHeader = (title, modalHeaderOnClick) => {
    return (
        <ModalHeader className="modal-box-header bg-primary">
            {title}
            <span className="text-white pointer">
                <i className="zmdi zmdi-close zmdi-hc-lg" onClick={modalHeaderOnClick()} />
            </span>
        </ModalHeader>
    );
};

export const initProps = () => {
    return {
        id: '',
        orgid: '',
        name: '',
        description: '',
        starred: false,
        frequently: false,
    };
};


// WEBPACK FOOTER //
// ./components/Agile/portfolio/portfolioMaintenance/common.js